import cx from 'clsx';
import styles from './Divider.module.scss';
import { Divider as AntDivider } from 'antd';

const Divider = ({ className = '', variant = 'solid', fullWidth = false }) => {
  return <AntDivider className={cx(fullWidth && styles.fullBleedDivider, className)} variant={variant} />;
};

export default Divider;
